import {
  PERFILES_GET_ROLE_BY_ID_BEGIN,
  PERFILES_GET_ROLE_BY_ID_SUCCESS,
  PERFILES_GET_ROLE_BY_ID_FAILURE,
  PERFILES_GET_ROLE_BY_ID_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW } from '../../../common/config';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getRoleById(id) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PERFILES_GET_ROLE_BY_ID_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(REACT_APP_API_ABM_FW + "/roles/" + id);
      doRequest.then(
        (res) => {
          if (res.data.success) {
            dispatch({
              type: PERFILES_GET_ROLE_BY_ID_SUCCESS,
              data: res,
            });
            resolve(res.data.data);
          } else {
            dispatch({
              type: PERFILES_GET_ROLE_BY_ID_FAILURE,
              data: { error: res.data.errorMessage },
            });
            reject(res.data.errorMessage);
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PERFILES_GET_ROLE_BY_ID_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetRoleByIdError() {
  return {
    type: PERFILES_GET_ROLE_BY_ID_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PERFILES_GET_ROLE_BY_ID_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getRoleByIdPending: true,
        getRoleByIdError: null,
      };

    case PERFILES_GET_ROLE_BY_ID_SUCCESS:
      // The request is success
      return {
        ...state,
        getRoleByIdPending: false,
        getRoleByIdError: null,
      };

    case PERFILES_GET_ROLE_BY_ID_FAILURE:
      // The request is failed
      return {
        ...state,
        getRoleByIdPending: false,
        getRoleByIdError: action.data.error,
      };

    case PERFILES_GET_ROLE_BY_ID_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getRoleByIdError: null,
      };

    default:
      return state;
  }
}
